import "core-js/modules/es.array.includes.js";
import styled from 'styled-components';
import Box from 'components/Box';
import { getLength, getSpacing } from 'utils/ui';
/**
 * This component renders its children in a regular grid.
 *
 * It automatically adjusts the number of displayed columns based on a provided
 * width that each item shouldn't go under, and a maximum column count.
 * This way the ideal number of columns doesn't have to be micro-managed via media
 * query breakpoints.
 *
 * Technique based on Codepen demo: https://codepen.io/mherchel/pen/xxXXbog
 */

var Tiles = styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(propName) {
    return !['maxColumnCount', 'minColumnWidth', 'gap'].includes(propName);
  }
}).withConfig({
  displayName: "Tiles",
  componentId: "sc-12l8ncn-0"
})(["--grid-gap:", ";--grid-column-count:", ";--grid-item--min-width:", ";--gap-count:calc(var(--grid-column-count) - 1);--total-gap-width:calc(var(--gap-count) * var(--grid-gap));--grid-item--max-width:calc( (100% - var(--total-gap-width)) / var(--grid-column-count) );display:grid;grid-template-columns:repeat( auto-fill,minmax( min( 100%,max(var(--grid-item--min-width),var(--grid-item--max-width)) ),1fr ) );gap:var(--grid-gap);"], function (p) {
  return getSpacing(p.gap || 'm', p.theme);
}, function (p) {
  return p.maxColumnCount || 4;
}, function (p) {
  return getLength(p.minColumnWidth || 200);
});
export default Tiles;